import requestv2 from "~/utils/http-v2";

const cronjobApi = {
    gets: async (params) => {
        const url = 'v2/cronjob';
        return await requestv2.get(url, {params});
    },
    add: async (params) => {
        const url = 'v2/cronjob';
        return await requestv2.post(url, params);
    },
    delete: async (id) => {
        const url = `v2/cronjob/${id}`;
        return await requestv2.delete(url);
    },
};

export default cronjobApi;
